// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__62j0E","range":"MonthRangeSwitch_range__wMbBk","disabled":"MonthRangeSwitch_disabled__2NVlB"};